import { CookieCategoryInfo } from '../types/cookieConsent';

export const COOKIE_CATEGORIES: CookieCategoryInfo[] = [
  {
    id: 'necessary',
    name: 'Задължителни (Необходими)',
    badge: 'Винаги активни',
    required: true,
    description: 'Тези бисквитки са строго необходими за правилното функциониране на уебсайта. Те осигуряват сигурност, защита срещу злонамерени заявки (CSRF), навигация между страниците и запазване на вашите лични предпочитания за поверителност.',
    services: ['Сигурност & Сесии', 'Локално съхранение на избора за бисквитки', 'Списък с Любими имоти'],
    cookiesList: [
      {
        name: 'varna_imoti_cookie_consent_v2',
        provider: 'varna-imoti.bg',
        purpose: 'Съхранява Вашето съгласие и избрани категории бисквитки съгласно регламентите на ЕС.',
        expiry: '12 месеца'
      },
      {
        name: 'varna_imoti_favorites',
        provider: 'varna-imoti.bg',
        purpose: 'Запазва избраните от Вас любими оферти за имоти, за да не се губят при презареждане.',
        expiry: '12 месеца'
      },
      {
        name: 'session_sec_token',
        provider: 'varna-imoti.bg',
        purpose: 'Предотвратява спам и осигурява защита при изпращане на форми за запитване.',
        expiry: 'Сесия'
      }
    ]
  },
  {
    id: 'analytics',
    name: 'Аналитични & Статистически',
    badge: 'Google Analytics & Search Console',
    required: false,
    description: 'Помагат ни да разберем как потребителите взаимодействат с уебсайта, кои оферти за имоти във Варна са най-търсени и как да оптимизираме скоростта и съдържанието. Данните са напълно анонимизирани и не съдържат директно идентифицираща лична информация.',
    services: [
      'Google Analytics 4 (GA4)',
      'Google Search Console (Органично търсене и видимост)',
      'Анонимна статистика за посещаемост'
    ],
    cookiesList: [
      {
        name: '_ga',
        provider: 'Google Ireland Limited',
        purpose: 'Използва се от Google Analytics за разграничаване на уникални потребители чрез анонимен идентификатор.',
        expiry: '2 години'
      },
      {
        name: '_ga_<container-id>',
        provider: 'Google Ireland Limited',
        purpose: 'Поддържа състоянието на сесията и отчита разгледаните страници с имоти.',
        expiry: '2 години'
      },
      {
        name: 'Google Search Console',
        provider: 'Google LLC',
        purpose: 'Позволява анализ на ключовите думи и качеството на търсенията на имоти.',
        expiry: 'Анонимни агрегирани данни'
      }
    ]
  },
  {
    id: 'marketing',
    name: 'Маркетинг, Реклама & Пиксели',
    badge: 'Google Ads & Meta Pixel',
    required: false,
    description: 'Използват се за проследяване на ефективността на рекламни кампании и показване на релевантни оферти за имоти в Google Търсене, Facebook и Instagram. Те предотвратяват натрапчиво показване на едни и същи реклами и измерват реализациите (конверсиите).',
    services: [
      'Google Ads (AdWords конверсии & ремаркетинг)',
      'Meta Pixel (Facebook Pixel & Instagram)',
      'Измерване на резултати от реклами'
    ],
    cookiesList: [
      {
        name: '_gcl_au',
        provider: 'Google Ads (Google LLC)',
        purpose: 'Измерва взаимодействията с реклами и запитванията за имоти, дошли през Google Ads.',
        expiry: '90 дни'
      },
      {
        name: '_fbp',
        provider: 'Meta Platforms Ireland Ltd.',
        purpose: 'Използва се от Facebook / Meta Pixel за показване на реклами на потребители, които вече са посетили сайта.',
        expiry: '90 дни'
      },
      {
        name: 'IDE / test_cookie',
        provider: 'Google DoubleClick',
        purpose: 'Проверява дали браузърът на потребителя поддържа рекламни бисквитки.',
        expiry: '1 година'
      }
    ]
  },
  {
    id: 'functional',
    name: 'Функционални & Интерактивни карти',
    badge: 'Google Maps',
    required: false,
    description: 'Позволяват зареждането на разширени външни функционалности, като интерактивната сателитна и пътна карта на Google Maps за локацията на офиса ни в гр. Варна, изчисляване на маршрути и упътвания.',
    services: [
      'Google Maps Embed API (Локация на офис Варна)',
      'Интерактивна навигация и изчисляване на маршрут',
      'Запазване на потребителски настройки на изгледа'
    ],
    cookiesList: [
      {
        name: 'NID, 1P_JAR, CONSENT',
        provider: 'Google Ireland Limited',
        purpose: 'Осигурява визуализирането на интерактивната карта на Google Maps и запазва настройките на изгледа.',
        expiry: '6 месеца'
      }
    ]
  }
];
